// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import Vant from 'vant';
import 'vant/lib/index.css';

// iconfont
import './css/iconfont/iconfont.css'
import './css/iconfont/iconfont.js'

import Vuex from 'vuex'
 
Vue.use(Vuex)


Vue.use(Vant)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js